<template>
    <div>
        <div class="row mt-4">
            <div class="col-3">
                <div class="card pb-0">
                    <div class="card-heade">
                        <font-awesome-icon :icon="['fas', 'circle-info']" />
                        <span class="ms-4"><strong>AVG Quote</strong></span>
                    </div>
                    <div class="card-body">
                        <span class="ms-4"><strong>$ {{ formatCurrency(avg_quote) }}</strong></span>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card pb-0">
                    <div class="card-heade">
                        <font-awesome-icon :icon="['fas', 'circle-info']" />
                        <span class="ms-4"><strong>AVG Price</strong></span>
                    </div>
                    <div class="card-body">
                        <span class="ms-4"><strong>$ {{ formatCurrency(avg_price) }}</strong></span>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card pb-0">
                    <div class="card-heade">
                        <font-awesome-icon :icon="['fas', 'circle-info']" />
                        <span class="ms-4"><strong>AVG Margin</strong></span>
                    </div>
                    <div class="card-body">
                        <span class="ms-4"><strong>{{ formatFractionPercent(avg_margin) }}</strong></span>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card pb-0">
                    <div class="card-heade">
                        <font-awesome-icon :icon="['fas', 'circle-info']" />
                        <span class="ms-4"><strong>Won</strong></span>
                    </div>
                    <div class="card-body">
                        <span class="ms-4"><strong>{{ Math.round(parseFloat(won)) }}%</strong></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'AVGHeader',
        props: {
            avg_quote: {
                type: Number,
                default: 0
            },
            avg_price: {
                type: Number,
                default: 0
            },
            avg_margin: {
                type: Number,
                default: 0
            },
            won: {
                type: Number,
                default: 0
            },
        },
        methods: {
            formatCurrency(value) {
                const numericValue = Number(value)
                return Number.isFinite(numericValue) ? numericValue.toFixed(2) : '0.00'
            },
            formatFractionPercent(value) {
                const numericValue = Number(value)
                return Number.isFinite(numericValue) ? `${(numericValue * 100).toFixed(1)}%` : '0.0%'
            }
        },
    }
</script>

<style scoped>
    .card {
        border-top: 4px solid var(--color-brand-primary);
        border-radius: var(--radius-lg);
        background: var(--color-surface-canvas);
        box-shadow: var(--shadow-sm);
        color: var(--color-text-primary);
    }

    .card-heade {
        color: var(--color-text-secondary);
    }

    .card-heade *,
    .card-body,
    .card-body * {
        color: inherit;
    }

    .card-body {
        color: var(--color-text-primary);
    }
</style>
